module.exports = __webpack_public_path__ + "img/printer.79250ecd.svg";